import React from 'react';
import Tooltip from 'components/controls/Tooltip';
import styled from 'styled-components';
import { MAX_FIELD_LENGTH } from '../constants';

interface Props {
  value: string | null | undefined;
}

const TruncatedCell: React.FC<Props> = ({ value }) => {
  if (!value) {
    return null;
  }

  const isTruncated = value.length > MAX_FIELD_LENGTH;
  const truncatedValue = value.substring(0, MAX_FIELD_LENGTH).replace(/\.$/, '');
  const displayValue = isTruncated ? truncatedValue + '...' : value;

  return (
    <Wrapper>
      <span>{displayValue}</span>
      {isTruncated && <Tooltip position="mouse">{value}</Tooltip>}
    </Wrapper>
  );
};

const Wrapper = styled.span`
  position: relative;
`;

export default TruncatedCell;
